<elcia-dashboard-kpi-tile
  class="h-full"
  [deltaPercent]="timeDelta()"
  [hint]="'dashboard.kpi.vs-previous' | translate"
  [label]="'dashboard.kpi.time-logged' | translate"
  [link]="timesheetsLink"
  [value]="monthToDate()"
  icon="pi-clock"/>
